import styled from "styled-components";
import DesignConstants from "../../../constants/DesignConstants";
import ArrowButton from "../../../basic/arrowButton/ArrowButton";

export const UnitWrapper = styled.div`
    background: white;
    user-select: none;
    scroll-margin-top: 180px;
`;

export const UnitHeaderWrapper = styled.div<{ hideBottomLine?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${DesignConstants.SPACES.S};
    border-bottom: ${(props) =>
        props.hideBottomLine ? "" : `${DesignConstants.BORDERS.MEDIUM} ${DesignConstants.COLORS.LIGHTEST_GREY}`};
    cursor: pointer;

    &:hover {
        background: ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    }
`;

export const SelectionWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: ${DesignConstants.SPACES.XS};
    width: 2rem;
    justify-content: space-around;

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        align-items: flex-start;
        align-self: flex-start;
        padding-top: ${DesignConstants.SPACES.XXS};
    }
`;

export const NameWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        flex-wrap: wrap;
        gap: 0.5rem;
    }
`;

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: right;
    margin-left: ${DesignConstants.SPACES.S};
`;

export const CardListingWrapper = styled.div`
    max-height: 20rem;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        max-height: unset;
    }
`;

export const UnitNameWrapper = styled.div`
    width: 100%;
    cursor: pointer;
`;

export const SelectedCardsCountWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: right;
    width: 100%;

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        width: 100%;
        align-items: center;
        justify-content: space-between;
    }
`;

export const OpenClosedWrapper = styled.div`
    cursor: pointer;
`;

export const StyledArrowButton = styled(ArrowButton)`
    padding: 0 !important;
`;

export const UserWarningWrapper = styled.div`
    margin-top: ${DesignConstants.SPACES.S};
    padding: 0 ${DesignConstants.SPACES.S};
`;

export const UnregisteredUserWarning = styled.span`
    font-style: italic;
`;

